export default {
  anonymous: true,
  session: null,
  accessToken: null,
};
